module.exports = __webpack_public_path__ + "img/shop-banner-1.cbe169bc.jpg";